var _rect, _path, _path2, _path3, _rect2, _path4, _rect3, _path5, _circle, _ellipse, _path6, _ellipse2, _ellipse3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWell2Img(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 38,
    viewBox: "0 0 40 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.263672,
    y: 1.68262,
    width: 22.8794,
    height: 32.8891,
    rx: 4.16667,
    fill: "#070C1A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.70386 4.41764C4.70386 2.11646 6.56934 0.250977 8.87052 0.250977H27.7064C30.0076 0.250977 31.8731 2.11646 31.8731 4.41764V28.1285C31.8731 29.2517 31.4197 30.3272 30.6156 31.1114L26.817 34.8162C26.0388 35.5752 24.9948 36 23.9078 36H8.87052C6.56934 36 4.70386 34.1345 4.70386 31.8333V4.41764Z",
    fill: "#65A5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.933 11.9976C16.524 11.6845 13.8001 11.434 14.1758 12.9369C14.6455 14.8155 18.4041 12.4673 19.813 10.1191C21.222 7.7709 21.6916 4.4834 20.2827 4.4834C18.8737 4.4834 19.813 7.7709 20.7523 10.1191C21.6916 12.4673 21.9761 13.6295 23.5702 15.7548C24.9791 17.6334 26.8577 15.7548 25.4487 14.8155C24.0507 13.8835 19.813 12.4673 17.933 11.9976Z",
    stroke: "white",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1992 29.4131H29.618L24.1992 35.2834V29.4131Z",
    fill: "#65A5FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.6602,
    y: 20.085,
    width: 12.0802,
    height: 2.21943,
    rx: 1.10972,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 20.9508L9.92398 22.7556L13.4873 19.1807",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.6602,
    y: 28.2119,
    width: 12.0802,
    height: 2.21943,
    rx: 1.10972,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 29.0836L9.92398 30.8884L13.4873 27.3135",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.445,
    cy: 29.3522,
    r: 8.57976,
    fill: "#00A661"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.298,
    cy: 26.4799,
    rx: 1.45549,
    ry: 1.45549,
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8371 27.6104L30.0362 28.7562M29.9773 30.3849L31.8371 31.8151",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.1222,
    cy: 29.5522,
    rx: 1.45549,
    ry: 1.45549,
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.298,
    cy: 32.6283,
    rx: 1.45549,
    ry: 1.45549,
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWell2Img);
export default __webpack_public_path__ + "static/media/well-2-img.9fc920d59ba2cedec65ebb969cdce954.svg";
export { ForwardRef as ReactComponent };